<template>
  <div class='bottomNav' :class="{ bottomNavRedesigned: isRedesignedPage }" :style="isRedesignedPage ? null : 'margin-top: 40px; font-weight:600; color:#333333; margin-left:-5px; margin-right: -5px;'">
    <div class ='row no-gutters bottomNavRow'>
      <div class='col'>
        <div id='nav_previous' class='d-none' style='padding-top:9px;'>
          <a href='javascript:void(0);' @click="changeStep('previous')" class='row no-gutters botNavLink'>
              <div class='col-auto my-auto'>
                  <img v-if='isRedesignedPage' src='../assets/images/leftarrow_red.svg' style='margin-left:15px;' :alt="$t('text.back')+' link'" />
                  <img v-else src='../assets/images/leftarrow.png' style='margin-left:15px;' :alt="$t('text.back')+' link'" />
              </div>
            <div class='col-auto my-auto' style='padding-left: 15px; height:25px;'>
              {{$t('text.back')}}
            </div>
          </a>
        </div>
        <div id='nav_letsgetstartedwrapper'>
            <div id='nav_letsgetstarted' class='d-none d-sm-block'>
                <div class='ctaBlock'>
                  <button @click="changeStep('next')" class='btn btn-primary ctaButton'>{{$t('text.page1_button')}}</button>
                  <div class='ctaSecure'>
                    <img src="../assets/images/cibc_allianz_shield.svg" class='ctaSecureIcon' alt="" />
                    <span>{{$t('text.page1_secureinfo')}}</span>
                  </div>
                </div>
            </div>
            
        </div>
        <div id='nav_printconfirmation' class='row d-none d-print-none'>
          <!--<button @click="printPage()" class='btn btn-primary' style='margin-left:35px; min-width: 200px;'>{{$t('text.page13_print')}}</button>-->
        </div>
      </div>
      <div class='col-auto col-sm'>
        <div id='nav_letsgetstartedwrapper2'>
          <div id='nav_letsgetstarted2' class='d-block d-sm-none'>
            <div class='ctaBlock ctaBlockMobile'>
              <button @click="changeStep('next')" class='btn btn-primary ctaButton'>{{$t('text.page1_button')}}</button>
              <div class='ctaSecure'>
                <img src="../assets/images/cibc_allianz_shield.svg" class='ctaSecureIcon' alt="" />
                <span>{{$t('text.page1_secureinfo')}}</span>
              </div>
            </div>
          </div>
        </div>
        <div id='nav_previouscenter' class='d-none'>
          <a href='javascript:void(0);' @click="changeStep('previous')" class='botNavLink row no-gutters'>
            <div class='col'></div>
            <div class='col-auto my-auto'>
              <img v-if='isRedesignedPage' src='../assets/images/leftarrow_red.svg' style='margin-left:15px;' :alt="$t('text.back')+' link'"/>
              <img v-else src='../assets/images/leftarrow.png' style='margin-left:15px;' :alt="$t('text.back')+' link'"/>
            </div>
            <div class='col-auto my-auto' style='padding-left: 15px; height:25px;'>
              {{$t('text.back')}}
            </div>
            <div class='col'></div>
          </a>
        </div>
      </div>
      <div class='col'>
        <div id='nav_next'>
          <div id='nav_next_enabled' class='no-gutters hoverSpot pull-right d-none'>
            <a href='javascript:void(0);' @click="changeStep('next')" class='botNavLink row no-gutters'>
              <div class='col'></div>
              <div class='col-auto my-auto' :style="isRedesignedPage ? 'padding-right:20px;height:25px;color: #333333' : 'padding-right:20px;height:25px;color: #336699'">
                {{$t('text.continue')}}
              </div>
              <div class='col-auto my-auto'>
                <img v-if='isRedesignedPage' id='proceed-enabled' alt='' src='../assets/images/rightarrow_enabled_red.svg' style='margin-right:15px;'/>
                <img v-else id='proceed-enabled' alt='' src='../assets/images/rightarrow_enabled.png' style='margin-right:15px;'/>
              </div>
            </a>
          </div>
          <div id='nav_next_disabled' class='no-gutters hoverSpot pull-right'>
            <a href='javascript:void(0);' @click="changeStep('next')" class='botNavLink row no-gutters navLinkDisabled'>
              <div class='col'></div>
              <div class='col-auto my-auto' :style="isRedesignedPage ? 'padding-right:20px;height:25px;color: #333333; opacity: 0.5;' : 'padding-right:20px;height:25px;color: #336699; opacity: 0.5;'">
                {{$t('text.continue')}}
              </div>
              <div class='col-auto my-auto'>
                <img id='proceed-disabled' alt='' src='../assets/images/rightarrow_disabled_red.svg' style='margin-right:15px;'/>
              </div>
            </a>
          </div>
        </div>
        <div id='nav_completeorder' class='row d-none' style='margin-top:0px; display:flex; justify-content:flex-end'>
            <div class='col-auto no-gutters hoverSpot'>
                <button @click="changeStep('next')" class='btn btn-primary' style='margin-top: 0px; min-width: 185px; width:auto; background: #C41F3E; font-family: "Fira Sans"'>{{$t('text.page12_completeorder')}}</button>
                <div v-if="!isRedesignedPage" style="display:flex;align-items:center;justify-content:center;margin-top:6px;">
                    <img src="../assets/images/cibc_allianz_shield.svg" class="secure-shield-icon"/>
                    <span class="secure-shield-icon-text">
                        {{ $t('text.page1_secureinfo') }}
                    </span>
                </div>
            </div>
        </div>
      </div>
    </div>
    <div v-if='isRedesignedPage && !isLandingPage' class='secureInfoRow'>
      <img src='../assets/images/cibc_allianz_shield.svg' class='secureInfoIcon' alt=""/>
      <span>{{$t('text.secureinfo')}}</span>
    </div>
  </div>
</template>

<script>
import bus from "../utils/bus.js";

export default {
  computed: {
    isRedesignedPage() {
      return this.$route.meta.redesigned === true;
    },
    isLandingPage() {
      return this.$route.path === "/";
    }
  },
  methods: {
    // Called when the step/page is moved forward or backward. This runs validation on the fields, and commits the values to the Store.
    changeStep(navigationDirection) {
      let doValidation=false;
      let skipNavigation=false;
      let targetStep="";

      if (navigationDirection==="next"&&this.$route.path==="/Questionnaire1"){
        if(document.getElementById("mq1n").checked===true) {
          document.getElementById("nav_previous").style.display = "none";
          document.getElementById("nav_next").style.display = "none";
          document.getElementById("mq1y").setAttribute("disabled","disabled");
          document.getElementById("not_eligible_warning").style.display = "block";

          skipNavigation=true;
        }
        else if (document.getElementById("mq1y").checked===false) {
          skipNavigation=true;
        }
      }

      // Skip Additional Travellers name if only 1 traveller
      if (navigationDirection ==="next"&&this.$route.path==="/ApplicantInfo"&&this.$store.state.numberOfTravellers==="1") {
        targetStep="/PaymentInfo";
        doValidation=true;
      } 
      else if (navigationDirection ==="previous"&&this.$route.path==="/PaymentInfo"&&this.$store.state.numberOfTravellers==="1") {
        targetStep="/ApplicantInfo";
      }
      // Don't migrate if no coverage types checked on page 2
      else if(navigationDirection==="next"&&this.$route.path==="/TypeOfCoverage"&&document.getElementById("wantsCancellation").checked===false&&document.getElementById("wantsMedical").checked===false){
        skipNavigation=true;
      }
      // Show Questionnaire if age of oldest traveller is 60 or older
      else if (navigationDirection==="next"&&this.$route.path==="/TravelPlans"&&document.getElementById("numberOfTravellers").value==="1"){
        if(document.getElementById("oldestTraveller").value>=60&&this.$store.state.wantsMedical===true){
          targetStep="/Questionnaire1";
          doValidation=true;
        }
        else {
          targetStep="/Quote";
          doValidation=true;
        }
      }
      else if (navigationDirection ==="next"&&this.$route.path==="/TravellerAges") {
        const numberOfTravellers = parseInt(this.$store.state.numberOfTravellers || "0", 10);
        const departureMoment = this.$moment(this.$store.state.departureDate, "MM/DD/YYYY", true);
        const calculationBase = departureMoment.isValid() ? departureMoment : this.$moment();
        let oldestTravellerAge = 0;

        for (let i = 1; i <= numberOfTravellers; i += 1) {
          const travellerDob = this.$moment(this.$store.state[`traveller${i}_dob`], "MM/DD/YYYY", true);
          if (travellerDob.isValid()) {
            const age = calculationBase.diff(travellerDob, "years", false);
            if (!Number.isNaN(age) && age > oldestTravellerAge) {
              oldestTravellerAge = age;
            }
          }
        }

        if (oldestTravellerAge > 0) {
          this.$store.commit("updateOldestTraveller", oldestTravellerAge);
        }

        if (oldestTravellerAge >= 60 && this.$store.state.wantsMedical === true) {
          targetStep="/Questionnaire1";
          doValidation=true;
        }
        else {
          targetStep="/Quote";
          doValidation=true;
        }
      } else if (navigationDirection ==="previous"&&this.$route.path==="/Quote"&&this.$store.state.wantsMedical===true){
        if(this.$store.state.oldestTraveller>=60){
          targetStep="/Questionnaire3";
        }
        else if(this.$store.state.numberOfTravellers==="1"){
          targetStep="/TravelPlans";
        }
      } else if (navigationDirection ==="previous"&&this.$route.path==="/Quote"&&this.$store.state.wantsMedical===false&&this.$store.state.numberOfTravellers==="1"){
        targetStep="/TravelPlans";
      } else if(navigationDirection==="previous"&&this.$route.path==="/Questionnaire1"&&this.$store.state.numberOfTravellers==="1"){
          targetStep="/TravelPlans"
      }
      // Otherwise navigate normally
      if(targetStep===""){
        console.log("BottomNav: Current route info:", {
          path: this.$route ? this.$route.path : 'no route',
          name: this.$route ? this.$route.name : 'no name',
          meta: this.$route ? this.$route.meta : 'no meta',
          navigationDirection: navigationDirection
        });
        
        if (this.$route && this.$route.meta) {
          if (navigationDirection === "next") {
            targetStep = this.$route.meta.nextStep || "";
            doValidation=true;
            console.log("BottomNav: Next step from meta:", this.$route.meta.nextStep);
          } else {
            targetStep = this.$route.meta.previousStep || "";
            console.log("BottomNav: Previous step from meta:", this.$route.meta.previousStep);
          }
        } else {
          console.error("BottomNav: No route or route meta available");
        }
      }
            
      console.log("BottomNav: Final navigation decision:", {
        skipNavigation: skipNavigation,
        hasRoute: !!this.$route,
        targetStep: targetStep,
        targetStepType: typeof targetStep
      });
      
      // Only emit if we have a valid target step
      if(skipNavigation===false && this.$route && targetStep && targetStep !== "") {
        bus.$emit("changeStep", this.$route.path, targetStep, doValidation);
      }
    }
  }
};
</script>

<style>
.btn-primary {
  color: white;
  font-family: Arial;
  border: 0px;
  background-color: rgb(51, 102, 153);
  height: 40px;
  width: 150px;
  border-radius: 3px;
}

a.botNavLink:visited,
a.botNavLink:link,
a.botNavLink:active,
a.botNavLink {
  padding:1px;    
  color: #333333;
}
a.navLink:hover {
    text-decoration:underline;
}

.navLinkDisabled {
  cursor: default !important;
}
a.navLinkDisabled:hover {
  text-decoration:none;
}

.secureInfoRow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-family: "Fira Sans", sans-serif;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  color: #6F6F6F;
}
.secureInfoIcon {
  width: 14px;
  height: 14px;
}

.bottomNavRedesigned {
  display: flex;
  flex-direction: column;
  gap: 32px;
  font-family: "Fira Sans", sans-serif;
  color: #333333;
}
.bottomNavRedesigned .bottomNavRow {
  align-items: center;
  padding-top: 16px;
}
.bottomNavRedesigned #nav_previous,
.bottomNavRedesigned #nav_previouscenter {
  padding-top: 0 !important;
}
.bottomNavRedesigned a.botNavLink {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 18px;
  font-weight: 600;
  color: #333333;
  text-decoration: none;
}
.bottomNavRedesigned a.botNavLink > .col {
  display: none;
}
.bottomNavRedesigned a.botNavLink > .col-auto {
  padding: 0 !important;
  height: auto !important;
  margin: 0 !important;
}
.bottomNavRedesigned #nav_previous a.botNavLink,
.bottomNavRedesigned #nav_previouscenter a.botNavLink {
  gap: 8px;
}
.bottomNavRedesigned #nav_previouscenter a.botNavLink {
  justify-content: center;
}
.bottomNavRedesigned #nav_previous a.botNavLink > .col-auto:last-child,
.bottomNavRedesigned #nav_previouscenter a.botNavLink > .col-auto:last-child {
  text-decoration: underline;
}
.bottomNavRedesigned #nav_previous img,
.bottomNavRedesigned #nav_previouscenter img {
  display: block;
  width: 20px;
  height: 20px;
  margin: 0 !important;
  object-fit: contain;
}
.bottomNavRedesigned #nav_next_enabled a.botNavLink,
.bottomNavRedesigned #nav_next_disabled a.botNavLink {
  justify-content: flex-end;
  gap: 12px;
}
.bottomNavRedesigned #nav_next img {
  display: block;
  width: 44px;
  height: 44px;
  margin: 0 !important;
}
.bottomNavRedesigned .ctaBlock {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}
.bottomNavRedesigned .ctaBlock .ctaButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 46px;
  margin: 0;
  padding: 14px 36px;
  background: #C41F3E;
  border: none;
  border-radius: 4px;
  font-family: "Fira Sans", sans-serif;
  font-size: 16px;
  line-height: 18px;
  font-weight: 700;
  color: #FFFFFF;
}
.bottomNavRedesigned .ctaButton:hover,
.bottomNavRedesigned .ctaButton:focus,
.bottomNavRedesigned .ctaButton:active,
.bottomNavRedesigned .ctaButton:not(:disabled):not(.disabled):active,
.bottomNavRedesigned .ctaButton:not(:disabled):not(.disabled).active {
  background-color: #C41F3E !important;
  border-color: #C41F3E !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.bottomNavRedesigned .ctaButton:hover,
.bottomNavRedesigned .ctaButton:not(:disabled):not(.disabled):active {
  background-color: #A51A34 !important;
  border-color: #A51A34 !important;
}
.bottomNavRedesigned .ctaButton:focus-visible {
  outline: 2px solid #1F2321;
  outline-offset: 2px;
}
.bottomNavRedesigned #nav_completeorder .complete-order-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.bottomNavRedesigned #nav_completeorder .btn-primary {
  min-width: 185px;
  height: 46px;
  margin: 0 !important;
  padding: 0 24px;
  border-radius: 4px;
  font-family: "Fira Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
}
.bottomNavRedesigned #nav_completeorder .btn-primary:hover,
.bottomNavRedesigned #nav_completeorder .btn-primary:focus,
.bottomNavRedesigned #nav_completeorder .btn-primary:active {
  background-color: #C41F3E !important;
  border-color: #C41F3E !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.bottomNavRedesigned #nav_completeorder .btn-primary:focus-visible {
  outline: 2px solid #1F2321;
  outline-offset: 2px;
}
.bottomNavRedesigned .ctaSecure {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  color: #6F6F6F;
}
.bottomNavRedesigned .ctaSecureIcon {
  width: 14px;
  height: 14px;
}
.redesignedPage1 .bottomNavRedesigned .bottomNavRow {
  padding-top: 12px;
}
@media (max-width: 767.98px) {
  .bottomNavRedesigned {
    gap: 24px;
  }
  .bottomNavRedesigned #nav_next img {
    width: 40px;
    height: 40px;
  }
}
@media (max-width: 575.98px) {
  .redesignedPage1 .bottomNavRedesigned .bottomNavRow {
    padding-top: 16px;
  }
  .bottomNavRedesigned .ctaBlockMobile {
    align-items: center;
    gap: 8px;
  }
  .bottomNavRedesigned .ctaBlockMobile .ctaButton {
    height: 44px;
    padding: 13px 36px;
    font-weight: 600;
  }
  .bottomNavRedesigned .ctaBlockMobile .ctaSecure {
    gap: 4px;
  }
  .bottomNavRedesigned .ctaBlockMobile .ctaSecureIcon {
    width: 12px;
    height: 12px;
  }
}
.complete-order-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}
.secure-shield-icon {
  width: 16px;
  height: 16px;
  padding-left: 6px;
  margin-left: 13px;
}
.secure-shield-icon-text {
  font-size: 11px;
  font-weight: 100 !important;
  font-family: 'Fira Sans';
  margin-left: 5px
}
</style>